import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from './index';

// First select the relevant part from the state
const selectDomain = (state: RootState) => state.workListState || initialState;

export const selectWorklistData = createSelector(
  [selectDomain],
  workListState => workListState.searhList,
);
export const selectContractStatus = createSelector(
  [selectDomain],
  workListState => workListState.contractStatus,
);
export const selectSelectedPreviewSection = createSelector(
  [selectDomain],
  workListState => workListState.selectedPreviewSection,
);
export const selectUsername = createSelector(
  [selectDomain],
  workListState => workListState.username,
);
export const selectUserEmail = createSelector(
  [selectDomain],
  workListState => workListState.userEmail,
);
export const selectErrorDialog = createSelector(
  [selectDomain],
  workListState => workListState.errorDialog,
);
export const selectErrorWordings = createSelector(
  [selectDomain],
  workListState => workListState.errorWordings,
);
export const selectDept = createSelector(
  [selectDomain],
  workListState => workListState.dept,
);
export const selectAccessRight = createSelector(
  [selectDomain],
  workListState => workListState.accessRight,
);
export const selectLeftMenuOpen = createSelector(
  [selectDomain],
  workListState => workListState.leftMenuOpen,
);

export const selectHistoryDate = createSelector(
  [selectDomain],
  workListState => workListState.historyDate,
)

export const selectWorkListLoading = createSelector(
  [selectDomain],
  workListState => workListState.loading,
);